import styles from './LoadingBarBlock.module.scss'
import { ReactComponent as LogoImage } from 'i/logo.svg'

export const LoadingBarBlock = ({ title }) => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loadingLogo}>
        <LogoImage />
      </div>
      <div className={styles.loadaingTitle}>{title}</div>
      <div className={styles.loadaingBar}>
        <div className={styles.loadaingBarIn} />
      </div>
    </div>
  )
}
